module.exports = __webpack_public_path__ + "static/media/brinfer_white.f3fecd8a.svg";